import {
  getSelectedMedPlanType,
  isGoogleShoppingTraffic,
  isMicrodosePaidTraffic,
} from "src/utils/userSegment/features";
import { getBaselineMicrodosePlanKey } from "@utils/plans";
import mapPlanKeyToNoomPlanId, { clinicalPlans } from "@utils/plansMapping";
import { MED_SKU } from "@utils/medEligibility";
import { isCoreClinicalRoute } from "@utils/userSegment";

export enum VariantName {
  mds3months = "mds3months",
  mds1month = "mds1month",
}

export function getMedCheckoutVariantsConfiguration(): {
  variantKey: VariantName;
  noomPlanId: string;
}[] {
  if (
    isCoreClinicalRoute() &&
    isGoogleShoppingTraffic() &&
    isMicrodosePaidTraffic() &&
    getSelectedMedPlanType() === MED_SKU.COMPOUNDED_MICRODOSE
  ) {
    return [
      {
        variantKey: VariantName.mds1month,
        noomPlanId:
          mapPlanKeyToNoomPlanId[clinicalPlans.compoundedMicrodoseOneMonth],
      },
      {
        variantKey: VariantName.mds3months,
        noomPlanId: mapPlanKeyToNoomPlanId[getBaselineMicrodosePlanKey()],
      },
    ];
  }

  return [];
}

export function hasCheckoutVariants(): boolean {
  return getMedCheckoutVariantsConfiguration().length > 1;
}
